export const faqPage = {
  path: '/faq',
  images: {
    hero: '/feature-pos.webp',
  },
  seoTitle: 'Restaurant POS System FAQ | Tillio POS',
  seoDescription:
    'FAQ about Tillio’s cloud-based POS system for restaurants—point of sale features, pricing, hardware, payments, and getting started.',
  hero: {
    title: 'Restaurant POS system FAQ',
    description:
      'Common questions about Tillio’s cloud-based point of sale system—features, pricing, hardware, and getting started.',
  },
}

export const faqs = [
  {
    question: 'What is Tillio POS?',
    answer:
      'Tillio is a cloud-based POS system for restaurants—an all-in-one point of sale system that combines orders, tables, payments, team management, time tracking, menu management, and analytics. It’s designed to be the only software you need to run your restaurant.',
  },
  {
    question: 'Is Tillio a cloud-based POS system?',
    answer:
      'Yes. Tillio is a cloud-based point of sale system. Your menu, orders, and reports sync across devices, so managers can see performance from the floor or the web admin without being tied to a single cash register.',
  },
  {
    question: 'Is Tillio a POS system for restaurants only?',
    answer:
      'Tillio is built as a restaurant point of sale system for full-service, cafés, bars, bakeries, fast casual, and fine dining—not general retail. Features like tables, kitchen display, and course-friendly tickets are designed for food service.',
  },
  {
    question: 'How does Tillio POS differ from other POS systems?',
    answer:
      'Unlike POS systems that require multiple integrations and separate apps, Tillio provides a unified restaurant POS system. You get point of sale, team management, time tracking, menu management, and analytics without switching tools.',
  },
  {
    question: 'What payment methods does Tillio POS support?',
    answer:
      'Tillio POS supports secure payment processing powered by Stripe. You can accept credit cards, debit cards, and contactless payments. All transactions are processed securely and in real-time.',
  },
  {
    question: 'How does Tillio work with Stripe?',
    answer:
      'Tillio is restaurant POS software. Card processing runs through Stripe on the account you connect with Stripe Connect. Your restaurant is the merchant of record: funds settle to your Stripe balance, and payouts and disputes stay in Stripe. See the Tillio + Stripe page for the full integration.',
  },
  {
    question: 'Can I manage multiple locations with Tillio POS?',
    answer:
      'Yes! Tillio POS is designed to scale with your business. You can manage multiple restaurant locations from a single account, with centralized reporting and management while maintaining location-specific settings and data.',
  },
  {
    question: 'Is there a mobile app?',
    answer:
      'Yes, Tillio POS is available on iPad devices, allowing you to manage your restaurant on the go. You can process orders, track tables, manage staff, view reports, and more from your tablet.',
  },
  {
    question: 'How does team management work?',
    answer:
      'Tillio POS includes comprehensive team management features. You can create staff profiles, assign roles and permissions, track employee hours with clock in/out functionality, manage schedules, and generate detailed time reports. All employee data is centralized and easy to manage.',
  },
  {
    question: 'Can I customize my menu?',
    answer:
      'Absolutely! Tillio POS provides full menu management capabilities. You can create menu items, organize them into categories, set pricing, manage availability, add descriptions and images, and update your menu in real-time across all devices.',
  },
  {
    question: 'What kind of reports and analytics are available?',
    answer:
      'Tillio POS provides comprehensive reporting and analytics. You can view sales reports, track performance metrics, analyze employee productivity, monitor inventory, and generate custom reports. All reports are available in real-time and can be accessed from anywhere.',
  },
  {
    question: 'How do I get started with Tillio POS?',
    answer:
      "Getting started is easy! Click 'Get Started' to fill out our onboarding form with information about your business. We'll review your information and contact you to set up your account and guide you through the setup process.",
  },
  {
    question: 'Is there customer support available?',
    answer:
      'Yes, we provide customer support to help you get the most out of Tillio POS. You can contact us via email at services@tilliopayment.com, and our support team is ready to assist you with any questions or issues you may have.',
  },
  {
    question: 'What does Tillio POS cost?',
    answer:
      'Tillio POS platform pricing starts at $99/month with unlimited usage across your devices. Card payments include a 1.1% Tillio flat rate plus Stripe’s own processing rates (see stripe.com/pricing). There are no setup fees. See our Pricing page for full details.',
  },
  {
    question: 'What hardware do I need?',
    answer:
      'Tillio runs on iPads and compatible tablets. Pair Stripe Terminal readers for card payments, add tablet stands for a command station, and connect kitchen displays or receipt printers as needed. Our Hardware page lists suggested compatible products—card readers, printers, stands, cash drawers, and more—filtered by category and platform.',
  },
]
